<template>
  <RadioGroup v-if="tagType === 'radio'" @change="handleInput" :value="getValueSting" :disabled="disabled">
    <Radio v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</Radio>
  </RadioGroup>

  <!-- <RadioGroup v-else-if="tagType==='radioButton'"  buttonStyle="solid" @change="handleInput" :value="getValueSting" :disabled="disabled">
    <a-radio-button v-for="(item, key) in dictOptions" :key="key" :value="item.value">{{ item.text }}</a-radio-button>
  </RadioGroup> -->

  <Select
    clearable
    :filterable="filterable"
    v-else-if="tagType === 'select'"
    :getPopupContainer="getPopupContainer"
    :placeholder="placeholder"
    :disabled="disabled"
    :default-label="value"
    :value="getValueSting"
    @on-change="handleInput"
  >
    <Option v-if="hasAll" :value="undefined">{{ defaultName || '请选择' }}</Option>
    <Option v-for="(item, key) in dictOptions" :key="key" :label="item.value" :value="item.value">
      <span style="display: inline-block; width: 100%" :title="item.text || item.label">
        {{ item.text || item.label }}
      </span>
    </Option>
  </Select>

  <Select
    mode="multiple"
    clearable
    :default-label="value"
    :value="value"
    v-else-if="tagType === 'selectMult'"
    :placeholder="placeholder"
    :getPopupContainer="getPopupContainer"
    @on-change="selectMultChange"
  >
    <Option v-if="hasAll" :value="undefined">{{ defaultName || '请选择' }}</Option>
    <Option v-for="(item, key) in dictOptions" :key="key" :label="item.value" :value="item.value">
      <span style="display: inline-block; width: 100%" :title="item.text || item.label">
        {{ item.text || item.label }}
      </span>
    </Option>
  </Select>
</template>

<script>
// import {ajaxGetDictItems,getDictItemsFromCache} from '@/api/api'
import applyApi from '@/api/apply'

export default {
  name: 'JDictSelectTag',
  props: {
    hasAll: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    defaultName: String,
    dictCode: String,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number, Array],
    type: String,
    getPopupContainer: {
      type: Function,
      default: (node) => node.parentNode
    }
  },
  data() {
    return {
      dictOptions: [],
      tagType: ''
    }
  },
  watch: {
    dictCode: {
      immediate: true,
      handler() {
        this.initDictData()
      }
    }
  },
  created() {
    if (!this.type || this.type === 'list') {
      this.tagType = 'select'
    } else {
      this.tagType = this.type
    }
    // 获取字典数据
    // this.initDictData();
  },
  computed: {
    getValueSting() {
      // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      // 当有null或“” placeholder不显示
      return this.value != null ? this.value.toString() : undefined
      // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
    }
  },
  methods: {
    initDictData() {
      // 优先从缓存中读取字典配置
      const dictList = localStorage.getItem('dictList') ? JSON.parse(localStorage.getItem('dictList')) : []
      if (dictList && dictList[this.dictCode]) {
        this.dictOptions = dictList[this.dictCode]
        return
      }

      // 根据字典Code, 初始化字典数组
      applyApi.ajaxGetDictItems(this.dictCode, null).then((res) => {
        if (res.success) {
          this.dictOptions = res.result
        }
      })
    },
    selectMultChange(e) {
      if (this.triggerChange) {
        this.$emit('on-change', e)
      } else {
        this.$emit('input', e)
      }
    },
    handleInput(e) {
      let val
      if (this.tagType === 'radio') {
        val = e.target.value
      } else {
        val = e
      }
      if (this.triggerChange) {
        this.$emit('on-change', val)
      } else {
        this.$emit('input', val)
      }
    },
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    }
  }
}
</script>

<style scoped></style>
